module.exports = __webpack_public_path__ + "static/logo-main-bd54c852d83e42b0e3ba18a3924840f5.svg";